import React, { Component } from "react";
import Header from "./header";
import "./homePage.css";
import Footer from "./footer";
import { Responsive, Container, Grid, Image, Divider } from "semantic-ui-react";
import BoardItem from "./boarditem";

// Presidents
import EricLui from "./img/board2023/1_P Eric Lui -min.jpg";
import ConstantMo from "./img/board2023/3_PE_Constant Mo (Vice President)-min.jpg";
import InezWu from "./img/board2023/5_VP_Inez Wu min.jpg";
import EdmondChan from "./img/board2023/7_ service director Edmond Chan (Immediate Past President)-min.jpg";
import AlexTsang from "./img/board2023/8_Alex Tsang (fellowship)-min.jpeg";
import HarrietLi from "./img/board2023/11_ Youth_Harriet Li (Service)-min.jpg";
import VivianChoi from "./img/board2023/12_Vivian Choi (International)-min.jpg";
import WallaceLaw from "./img/board2023/13_Wallace Law (membership)-min.jpg";
import BonnieWong from "./img/board2023/15_DEI_Bonnie Wong.jpeg";
import KentLi from "./img/board2023/16_kent_li.jpeg";
import EricChiu from "./img/board2023/17_eric_chiu.jpeg";

class Member extends Component {
  // President has to be in the middle among three
  presidents = [
    {
      id: 1,
      name: "Ms. Inez Wu",
      image: InezWu,
      title: "President",
      htmlcontent: "",
    },
    {
      id: 2,
      name: "Mr. Constant Mo",
      image: ConstantMo,
      title: "Immediate Past President",
      htmlcontent: "",
    },
    {
      id: 3,
      name: "Mr. Kent Li",
      image: KentLi,
      title: "President Elect",
      htmlcontent: "",
    },
  ];

  board = [
    {
      id: 1,
      name: "Mr. Eric Lui",
      image: EricLui,
      title: "Secretary",
      htmlcontent: "",
    },
    {
      id: 2,
      name: "Mr. Alex Tsang",
      image: AlexTsang,
      imageScale: "0.85,0.85",
      imagePos: "center top",
      title: "Treasurer",
      htmlcontent: "",
    },
    {
      id: 3,
      name: "Ms. Harriet Li",
      image: HarrietLi,
      title: "Membership Director",
      htmlcontent: "",
    },
    {
      id: 4,
      name: "Mr. Constant Mo",
      image: ConstantMo,
      title: "Fellowship Director",
      htmlcontent: "",
    },
    {
      id: 5,
      name: "Mr. Edmond Chan",
      image: EdmondChan,
      title: "Service Director (Local)",
      htmlcontent: "",
    },
    {
      id: 6,
      name: "Mr. Kent Li",
      image: KentLi,
      title: "Service Director (Youth)",
      htmlcontent: "",
    },
    {
      id: 7,
      name: "Ms. Vivian Choi",
      image: VivianChoi,
      title: "Foundation Director",
      htmlcontent: "",
    },
    {
      id: 8,
      name: "Mr. Wallace Law",
      image: WallaceLaw,
      title: "Public Image Director",
      htmlcontent: "",
    },
    {
      id: 9,
      name: "Mr. Eric Chiu",
      image: EricChiu,
      imageScale: "0.85,0.85",
      imagePos: "center top",
      title: "DEI Chair",
      htmlcontent: "",
    },
    {
      id: 10,
      name: "Mr. Alex Tsang",
      image: AlexTsang,
      imageScale: "0.85,0.85",
      imagePos: "center top",
      title: "PPE Chair",
      htmlcontent: "",
    },
    {
      id: 11,
      name: "Ms. Bonnie Wong",
      image: BonnieWong,
      title: "Liaison for Service (International)",
      htmlcontent: "",
    },
  ];

  componentWillMount() { }
  render() {
    return (
      <div className="Homepage BoardMemberPage">
        <Header page="aboutus" />

        <div className="homeContentWhite">
          <a id="board">
            <Container>
              <div className="AboutUsText left">
                Rotary Club of Central is committed to achieving high standards
                of club governance.
                <br />
                <br />
                The Board of Directors (the "Board") believes that good club
                governance is the key to enhance our club transparency,
                accountability and credibility, and to attain the confidence of
                our partners and service users.
              </div>
              <div className="AboutUsTitle">
                Board Members of the Rotary Club of Central (2025-2026)
              </div>
              <br />
              <br />

              <div className="boardRowPresidents">
                <Grid centered>
                  <Grid.Row className="boardRowPresidentsRow">
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                      <BoardItem isTopManagement board={this.presidents[0]} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                      <BoardItem isTopManagement board={this.presidents[1]} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                      <BoardItem isTopManagement board={this.presidents[2]} />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
              <Grid centered>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[0]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[1]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[2]} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[3]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[4]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[5]} />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[6]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[7]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[8]} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[9]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    <BoardItem board={this.board[10]} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={4} computer={4}>
                    {this.board[11] && <BoardItem board={this.board[11]} />}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </a>
        </div>
        <div className="boardBoxes">
          <a
            href="https://www.facebook.com/groups/199332850129610/"
            target="_blank"
            className="boardBox"
          >
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Sister Clubs</h2>
              <p className="boardBoxDesc">Rotary Club of Taipei Diamond</p>
            </div>
          </a>
          <div className="boardBox">
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Rotaract Club</h2>
              <p className="boardBoxDesc">Rotaract Club of Central</p>
            </div>
          </div>
          <div className="boardBox">
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Kideract Club</h2>
              <p className="boardBoxDesc">Kideract Club of Central</p>
            </div>
          </div>
          <div className="boardBox">
            <div className="boardBoxInner">
              <h2 className="boardBoxTitle">Adopt-A-School</h2>
              <p className="boardBoxDesc">Tuen Mun Catholic Secondary School</p>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default Member;
